import { css, styled } from 'next-yak';

import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import { scale130, scale150, scale160 } from '@xing-com/tokens';

import { SkeletonPillShape } from '../';

import type { SkeletonButtonSize } from './skeleton-button.types';

type ButtonTransientProps = {
  $size?: SkeletonButtonSize;
  $sizeConfined?: SkeletonButtonSize;
  $sizeWide?: SkeletonButtonSize;
};

// *** Sizes ***
export const sizes = {
  small: css`
    height: ${scale130};
  `,
  medium: css`
    height: ${scale150};
  `,
  large: css`
    height: ${scale160};
  `,
};

// *** Components ***
export const Button = styled(SkeletonPillShape)<ButtonTransientProps>`
  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return sizes.small;
      case 'medium':
        return sizes.medium;
      case 'large':
        return sizes.large;
      default:
        return $size satisfies undefined;
    }
  }};

  ${({ $sizeConfined }) => {
    switch ($sizeConfined) {
      case 'small':
        return css`
          @media ${mediaConfined} {
            ${sizes.small}
          }
        `;
      case 'medium':
        return css`
          @media ${mediaConfined} {
            ${sizes.medium}
          }
        `;
      case 'large':
        return css`
          @media ${mediaConfined} {
            ${sizes.large}
          }
        `;
      default:
        return $sizeConfined satisfies undefined;
    }
  }};

  ${({ $sizeWide }) => {
    switch ($sizeWide) {
      case 'small':
        return css`
          @media ${mediaWide} {
            ${sizes.small}
          }
        `;
      case 'medium':
        return css`
          @media ${mediaWide} {
            ${sizes.medium}
          }
        `;
      case 'large':
        return css`
          @media ${mediaWide} {
            ${sizes.large}
          }
        `;
      default:
        return $sizeWide satisfies undefined;
    }
  }};
`;
